import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    USER_LOADED_SUCCESS,
    USER_LOADED_FAIL,
    AUTHENTICATED_SUCCESS,
    AUTHENTICATED_FAIL,
    LOGOUT, REFRESH_SUCCESS, SET_MAINTENANCE_STATUS
} from '../action/types';
import axios from 'axios';
import jwt_decode from 'jwt-decode';

const checkIfOperator = (token: string) => {
    if (token) {
        const decodedToken = jwt_decode(token);
        if (decodedToken.resource_access && decodedToken.resource_access[process.env.REACT_APP_KEYCLOAK_CLIENT_ID] && decodedToken.resource_access[process.env.REACT_APP_KEYCLOAK_CLIENT_ID].roles) {
            const roles: string[] = decodedToken.resource_access[process.env.REACT_APP_KEYCLOAK_CLIENT_ID].roles;
            return roles.find((role: string) => role.toLowerCase() === "operatore");
        }
    }
    return false;
};

const initialState = {
    access: null,
    refresh: null,
    maintenanceStatus: null,
    isAuthenticated: false,
    user: null,
    isOperator: false
};

export default function (state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case SET_MAINTENANCE_STATUS:
            return {
                ...state,
                maintenanceStatus: payload
            }
        case AUTHENTICATED_SUCCESS:
            return {
                ...state,
                isAuthenticated: true
            }
        case LOGIN_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                access: payload.access_token,
                refresh: payload.refresh_token,
                isOperator: checkIfOperator(payload.access_token)
            }
        case REFRESH_SUCCESS:
            return {
                ...state,
                isAuthenticated: true,
                access: payload.access_token,
                refresh: payload.refresh_token,
                isOperator: checkIfOperator(payload.access_token)
            }
        case USER_LOADED_SUCCESS:
            return {
                ...state,
                user: payload
            }
        case AUTHENTICATED_FAIL:
            return {
                ...state,
                isAuthenticated: false
            }
        case USER_LOADED_FAIL:
            return {
                ...state,
                user: null
            }
        case LOGIN_FAIL:
            return {
                ...state,
                access: null,
                refresh: null,
                isAuthenticated: false,
                user: null
            }
        case LOGOUT:
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            localStorage.removeItem('id');
            return {
                ...state,
                access: null,
                refresh: null,
                isAuthenticated: false,
                user: null
            }
        default:
            return state
    }
};
